/**
 * Standard (HL7-minted) FHIR extension URLs we read or write.
 *
 * These live here rather than beside their first caller because an extension
 * URL is a wire contract: whoever writes it and whoever reads it must agree on
 * the byte string, and those are usually different libs on different sides of
 * the API. `@medplum/core` exports only a handful of one-off URL constants and
 * none of these, so they have to be spelled somewhere — this is that place.
 *
 * Eluve-minted extension URLs belong on `ELUVE_FHIR_NAMESPACE` instead; see
 * `./namespace.ts` for the grammar.
 */

/** A Location's IANA timezone, carried as `valueCode` (e.g. `America/New_York`). */
export const FHIR_TIMEZONE_EXTENSION =
  'http://hl7.org/fhir/StructureDefinition/timezone';
